/**
 * @typedef {Object} BillingStatusResponseDto
 * @property {number} balance
 * @property {boolean} isNegative
 * @property {string} [negativeSinceDate]
 */

/**
 * @typedef {Object} OrgTransactionResponseDto
 * @property {number} transactionId
 * @property {number} amount
 * @property {string} transactionType
 * @property {string} [notes]
 * @property {string} createdDate
 * @property {string} createdBy
 */

const BASE_PATH = 'v1/Billing';

export default function (instance) {
  return {
    /**
     * The caller's own org's current balance and overdraft state.
     * @returns {Promise<{data: BillingStatusResponseDto}>}
     */
    getStatus() {
      return instance.get(`${BASE_PATH}/status`);
    },

    /**
     * The caller's own org's transaction ledger, newest first.
     * @param {Object} [params]
     * @param {number} [params.limit]
     * @returns {Promise<{data: OrgTransactionResponseDto[]}>}
     */
    getTransactions(params = {}) {
      return instance.get(`${BASE_PATH}/transactions`, { params });
    }
  };
}
